import { useMemo } from 'react';
import * as atlas from 'azure-maps-control';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';

export function useAuthOptions(azureMapsClientId: string) {

  const apiClient = useChatApiClient();

  const authOptions: atlas.ServiceOptions['authOptions'] = useMemo(() => {
    return {
      authType: atlas.AuthenticationType.anonymous,
      clientId: azureMapsClientId,
      getToken: async (resolve, reject) => {
        try {
          const result = await apiClient.location.getAzureMapsToken();
          resolve(result.token);
        } catch (e) {
          reject(e);
        }
      },
    };
  }, [apiClient.location, azureMapsClientId]);

  return authOptions;
}
